import React from 'react'
import styles from './Flow.module.scss'

interface Props {
  contents: {
    num: number
    title: string
    description: string
    src: string
  }[]
}

const Flow: React.FC<Props> = ({ contents }) => {
  const listItems = contents.map((item, i) => (
    <React.Fragment key={i}>
      <li>
        <div className={styles.flow_image}>
          <img src={item.src} alt="" />
        </div>
        <div className={styles.flow_text}>
          <div className={styles.flow_title}>{item.title}</div>
          <p className={styles.flow_description}>{item.description}</p>
        </div>
      </li>
      {i < contents.length - 1 && (
        <div className={styles.next}>
          <img src="/images/LP/LP202407/Icon/BsCaretDownFill.svg" alt="next" />
        </div>
      )}
    </React.Fragment>
  ))
  return (
    <div className={styles.flow_section}>
      <div className={styles.wrapper}>
        <div className={styles.flow_section_title}>ご利用の流れ</div>
        <ul className={styles.flow_list}>{listItems}</ul>
      </div>
    </div>
  )
}
export default Flow
